export default class Helpers {
  public static clone<T>(a: T): T {
    return JSON.parse(JSON.stringify(a));
  }

  public static indieUrl(relativePath: string){
    return process.env.VUE_APP_INDIE_BASE + relativePath;
  }

  public static airlineIconUrl(airlineCode: string){
    //return this.indieUrl("/img/airlines/32x32/" + airlineCode + ".png");
    return "/img/airlines/" + airlineCode.toUpperCase() + ".png";
  }

  public static removeArrItem(arr: any[], itemIndex: number){
    if(itemIndex >= 0){
      arr.splice(itemIndex, 1);
    }
    return arr;
  }

  /**
   * A silent version of this.$router.replace
   * Silent means it will not refresh the page all over again.
   * Follow feature request for vue: https://github.com/vuejs/vue-router/issues/703
   *
   * @param newPath
   */
  public static routeReplaceSilent(newPath: string){
    window.history.replaceState({}, document.title, newPath);
  }

  public static isEmpty(value: any) {
    if(value === undefined){
      return true;
    }
    if(value === null){
      return true;
    }
    if(value === 0){
      return true;
    }
    if(value === ""){
      return true;
    }
    if(value.length !== undefined && value.length === 0){
      return true;
    }
    if(value.constructor && value.constructor === Object && Object.keys(value).length === 0){
      return true;
    }

    return false;
  }

  public static nl2br(value: any){
    return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
  }

  public static makeToast(parentComponent: any, bvToast: any, message: string, title="Success"){
    const h = parentComponent.$createElement;
    let msgLines = message.split("\n");
    let vNodes = [];
    for(let line of msgLines){
      if(this.isEmpty(line)){
        vNodes.push(h('hr'));
      } else {
        vNodes.push(h('div', {}, line));
      }
    }
    let vNodesMsg = h (
      'div',
      {class: ['text-left', 'mb-0']},
      vNodes
    );
    bvToast.toast([vNodesMsg], {
      title: title,
      autoHideDelay: 5000,
      appendToast: true,
      variant: 'success'
    });
  }

  public static makeErrorToast(component: any, bvToast: any, message: string, title="Error"){
    const h = component.$createElement;
    let msgLines = message.split("\n");
    let vNodes = [];
    for(let line of msgLines){
      if(this.isEmpty(line)){
        vNodes.push(h('hr'));
      } else {
        vNodes.push(h('div', {}, line));
      }
    }
    let vNodesMsg = h (
      'div',
      {class: ['text-left', 'mb-0']},
      vNodes
    );
    bvToast.toast([vNodesMsg], {
      title: title,
      autoHideDelay: 12000,
      appendToast: true,
      variant: 'danger'
    });
  }

  public static isBootstrapSmallOrLess(){
    if(screen.width < 768){
      return true;
    }
    return false;
  }

  public static isBootstrapLargeOrMore(){
    if(screen.width >=922){
      return true;
    }
    return false;
  }
}
